import type { ApiResponseError } from "@rawa/api-client/ApiResponseError"
import styles from "./SaveRefusal.module.css"

/**
 * Why a save was refused, as sent: the one reason, or every rule it broke
 * when there were several (ADR-033 rule 7), so the administrator fixes them
 * all before trying again.
 */
export function SaveRefusal({ error }: { error: ApiResponseError }) {
  if (error.problems.length <= 1) return <>{error.message}</>
  return (
    <ul className={styles.problems}>
      {error.problems.map((problem) => (
        <li key={`${problem.code}:${problem.message}`}>{problem.message}</li>
      ))}
    </ul>
  )
}
